import { useState, useEffect, useRef } from 'react';
import React, { Component } from "react";
import { propTypes } from 'react-bootstrap/esm/Image';
//import ReactPlayer from 'react-player';

import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
//import PinchZoomPan from "react-responsive-pinch-zoom-pan";
import Spinner from '../components/Spinner'
//import {  getMinScale} from './Utils';
//import { createSelector } from 'reselect';
import parse from 'html-react-parser';

// https://stackoverflow.com/questions/43411864/how-to-install-package-from-github-repo-in-yarn
// no: yarn add 'react-responsive-pinch-zoom-pan-tb@https://github.com/trentbrooks/react-responsive-pinch-zoom-pan'
// yarn add git+https://github.com/trentbrooks/react-responsive-pinch-zoom-pan#master

import {OutlineButtonTextIcon, ButtonTextIcon, ButtonIcon} from '../components/Button'

// assets
// import closeIcon from '../assets/icons/icon_close.svg'
// import closeIcon from '../assets/icons/button_close_blk.svg'
import zoomInIcon from '../assets/icons/button_zoom_in.svg' //icon_zoomin.svg'
import zoomOutIcon from '../assets/icons/button_zoom_out.svg' //icon_zoomout.svg'
import zoomInHoverIcon from '../assets/icons/button_zoom_in_hover.svg' //icon_zoomin.svg'
import zoomOutHoverIcon from '../assets/icons/button_zoom_out_hover.svg' //icon_zoomout.svg'

// import { CircleButton } from './Button';
// import { CaptionBox } from './CaptionBox';
// import closeIcon from '../assets/icons/icon_close.svg'

import { atom, useAtom } from 'jotai'
import {isSmallAtom, videoPlayingAtom} from '../atoms/atom.config.js'
//import {isSmallAtom,priceAtom, messageAtom, productAtom, textAtom,titleAtom,audioFileAtom} from '../atoms/atom.config.js'

// import { ReactComponent as CaptionIcon } from "../assets/icons/button_image_caption_updated.svg";

// could be image or video
const MediaItem = ({
  onclose,
  src,
  caption,
  credit,
  subtitles,
  spinner,
  alt  
  }) => {

    const [image, setImage] = useState(null);
    const [initScale, setInitScale] = useState(1);
    const [initPos, setInitPos] = useState({x:0,y:0});
    const [refresh, setRefresh] = useState(false);
    const [showImage, setShowImage] = useState(false);
    const [captionHeight, setCaptionHeight] = useState(0);
    const [zoomScales, setZoomScales] = useState(null);
    const [isSmall, setIsSmall] = useAtom(isSmallAtom);
    const [isVideoPlaying, setIsVideoPlaying] = useAtom(videoPlayingAtom);
    //const src = itemData.filename
    //console.log(itemData)
    const [clickCounter, setClickCounter] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    // const [isPanning, setIsPanning] = useState(false);

    const [isZoomInHover, setIsZoomInHover] = useState(false);
    const [isZoomOutHover, setIsZoomOutHover] = useState(false);
    

    const zoomLayerRef = useRef(null)
    const captionLayerRef = useRef(null)
    const imageRef = useState(null);

    const isVideo = (url) => {
      let extension = url.split('.').pop();
      //console.log("MediaBackground", extension)
      return extension.toLowerCase() == "mp4" || extension.toLowerCase() == "m4v";
    };
    

    /*const zoomIn = () => {
      if(zoomLayerRef.current && zoomScales) {
        console.log("zoomIn", zoomScales)
        if(zoomScales.cur < zoomScales.max) {
          zoomLayerRef.current.handleZoomInClick()
          setClickCounter(clickCounter+1)
        }
        
        // console.log(zoomLayerRef)
        // const minScale = getMinScale(zoomLayerRef.current.state, zoomLayerRef.current.props)
        // const curScale = zoomLayerRef.current.state.scale
        // const maxScale = zoomLayerRef.current.props.maxScale
        // console.log(curScale, minScale, maxScale)
      }
      
    };
    const zoomOut = () => {
      if(zoomLayerRef.current && zoomScales) {
        console.log(zoomScales)
        if(zoomScales.cur > zoomScales.min) {
          zoomLayerRef.current.handleZoomOutClick()
          setClickCounter(clickCounter+1)
        }

        // console.log(zoomLayerRef)
        // const minScale = getMinScale(zoomLayerRef.current.state, zoomLayerRef.current.props)
        // const curScale = zoomLayerRef.current.state.scale
        // const maxScale = zoomLayerRef.current.props.maxScale
        // console.log(curScale, minScale, maxScale)
      }
    };*/

    const getCaption = () => {
      //{caption} - {credit}
      //console.log("getCaption", credit, caption)
      if(credit != "") {
        return caption + " - " + credit
      }

      return caption;
    };

    const getCaptionHeight = () => {
      if(captionLayerRef.current) {
        const slideHeight = captionLayerRef.current.offsetHeight; 
        console.log("captionLayerRef", slideHeight)
        return slideHeight
      }
      return 0;
      // const node = document.getElementById('zoom-caption');
      // if(node) {
      //   //const slidePos = node.offsetTop;
      //   const slideHeight = node.offsetHeight;     
      //   //setCaptionHeight(slideHeight); // force re-render?   
      //   return slideHeight+'px';
      // }
      // return '0px';
    };


    const getContainerHeight = () => {
      const container = document.getElementById('zoomcontainer');
      const ht = container?.clientHeight || 720;
      return ht
    };

    const wrapperStyle = {
      height: getContainerHeight()+'px',
      width: '100%'
    };
    
    // const transformOptions = {
    //   initialScale: 1,
    //   minScale: 0.5,
    //   maxScale: 2
    // };


    // need these 2 functions to determine when at min and max zoom to disable buttons
    // copied: https://github.com/bradstiff/react-responsive-pinch-zoom-pan/blob/master/src/Utils.js
    /*const getAutofitScale = (containerDimensions, imageDimensions) => {
      const { width: imageWidth, height: imageHeight } = imageDimensions || {};
      if (! (imageWidth > 0 && imageHeight > 0) ) {
          return 1;
      }
      return Math.min(
          containerDimensions.width / imageWidth,
          containerDimensions.height / imageHeight,
          1
      );
    }    
    const getMinScale = createSelector(
        state => state.containerDimensions,
        state => state.imageDimensions,
        (state, props) => props.minScale,
        (containerDimensions, imageDimensions, minScaleProp) => 
            String(minScaleProp).toLowerCase() === 'auto'
                ? getAutofitScale(containerDimensions, imageDimensions)
                : minScaleProp || 1
    )
    // custom
    const getCustomZoomScales = () => {
      //console.log(zoomLayerRef.current)
      if(zoomLayerRef.current) {
        const minScale = getMinScale(zoomLayerRef.current.state, zoomLayerRef.current.props)
        const curScale = (zoomLayerRef.current.state.scale) ? zoomLayerRef.current.state.scale : 1
        const maxScale = zoomLayerRef.current.props.maxScale
        return {min:minScale, max:maxScale, cur:curScale}
      }
      return {min:1, max:4, cur:1}
    };*/

    useEffect(() => {
      //console.log(getCaptionHeight())
      // FIXED: toggling bodystyle off/on was changing the window scroll position.y
      //document.body.style.overflow = 'hidden';

      const ch = getCaptionHeight()
      setCaptionHeight(ch)
      console.log("zoom item useEffect", captionHeight)

      //const zs = getCustomZoomScales()
      //setZoomScales(zs)

      if(isVideo(src)) setIsVideoPlaying(true)

      return ()=> {
        //document.body.style.overflow = 'unset';
        if(isVideo(src)) setIsVideoPlaying(false)
      };
   }, [captionHeight,clickCounter,videoPlayingAtom]);

   // image preloader
    useEffect(() => {
      if(!isVideo(src) && isLoading && !imageRef.current ) {
        const image = new Image();
        image.onload = () => {
          // setShowImage(true);
          //setImage(image);
          imageRef.current = image
          
          
    
          //setInitPos({x:500,y:500})
          //setInitScale(1)

          const container = document.getElementById('zoomcontainer');
          const wd = container?.clientWidth || 1280;
          const ht = container?.clientHeight || 720;
          const imgWd = image.width;
          const imgHt = image.height;
          const scaledWd = wd/imgWd;
          const scaledHt = ht/imgHt;
          //console.log("loaded image...", image, "w/h:", imgWd, imgHt);
          if (scaledWd < scaledHt) {
            setInitScale(1);
            console.log('using wRatio (portrait)')
          } else {
            const v = scaledHt/Math.min(1, scaledWd)
            console.log('usingHRatio (landscape)', scaledHt, scaledWd, scaledHt/scaledWd, v, wd, ht);
            setInitScale(v); //scaledHt/Math.min(1, scaledWd));
          }
          // console.log("init scale", initScale)
          // setRefresh(true);
          console.log("width:", wd, imgWd, scaledWd, imgWd*scaledWd); //-(wd-imgWd)
          //console.log("height:", ht, imgHt, scaledHt)
          //setInitPos({x:(wd/2)-((imgWd*scaledHt)/2),y:(scaledHt/2)})

          // setTimeout(() => {
            // setIsLoading(false)
          // },5000);
          setIsLoading(false)
          //setRefresh(true)
        }
        image.src = src;        
      }
      
    }, [src])

    //const cnPaddingBottomCalc = `h-full w-full pb-[${captionHeight}] ;padding-bottom:88px`;
    //const zoomScales = getZoomScales()
    // let cnZoomIn = `bg-rba-gray p-[9px] cursor-pointer` 
    // let cnZoomOut = cnZoomIn 
    // if(zoomScales) {
    //   cnZoomIn = `bg-rba-gray p-[9px] ${(zoomScales.cur >= zoomScales.max) ? 'opacity-50' : 'cursor-pointer' }` 
    //   cnZoomOut = `bg-rba-gray p-[9px] ${(zoomScales.cur <= zoomScales.min) ? 'opacity-50' : 'cursor-pointer' }`
    // }     
    const cnFade = `${(isLoading) ? '' : 'animate-fadein'}`;
    //const cnZoomTransition = `${(isPanning) ? ' duration-0' : ' transition duration-300'}`
    //console.log("zoom scales", zoomScales, captionHeight) 

    const transformOptions = {
      initialScale: 1.0,
      minScale: 0.2,
      maxScale: 2
    }

    return (
      <div className='flex h-full '>
        {isLoading && <div className='w-full h-screen absolute'><Spinner icon={spinner} /></div>}
        { isVideo(src) ?
        <video autoPlay playsInline controls loop disablePictureInPicture controlsList="nodownload" id='video' className='h-full w-full ' onLoadedData={() => {
          //setTimeout(() => {
            console.log("MediaItem videoloadeddata event")
            setIsLoading(false)
          //},2000);
        }}>
          <source src={src} type='video/mp4'/>
        </video>
        : 
        <div>
          {/* custom zoom image */}
          <div className='absolute h-full w-full animate-fadein ' id='zoomcontainer' >

            {/* NOTE!: we cant apply the captionHeight padding css until AFTER its loaded ??? ALSO- doesnt work with arbitrary values as react state vars in classnames- need to use inline style: https://github.com/tailwindlabs/tailwindcss/discussions/7036 */}
            {/* {(captionLayerRef.current && captionHeight > 0) && */}
            {/* // <div className='w-full h-full' style={{paddingBottom:captionHeight+'px'}}> */}
            { !isLoading && 
              <div className='w-full h-full animate-fadein' >
                {/* 1. using react-responsive-pinch-zoom-pan- animation class makes panning suck */}
                {/* <PinchZoomPan ref={zoomLayerRef} maxScale={4} position={'center'} zoomButtons={false}>
                  <img src={src} className={'h-displayHt w-full object-contain transition duration-300'+cnFade} id='image' alt=""  onLoad={() => {
                    //setTimeout(() => {
                      console.log("MediaItem imageloaded event")
                      setIsLoading(false)
                    //},10000);
                  }}/>
                </PinchZoomPan> */}

                {/* 2. using react-zoom-pan-pinch- wrong position on load */}
                {/* {!isLoading && */}
                <TransformWrapper
                  className='animate-fadein'
                  // centerOnInit
                  centerOnInit={true}
                  centerZoomedOut={true}
                  limitToBounds={false}
                  //initialPositionX={initPos.x}
                  //initialPositionY={initPos.y}
                  //options={transformOptions}
                  minScale={initScale}
                  initialScale={initScale}
                  ref={zoomLayerRef}
                  // options={transformOptions}
                  maxScale={3}
                  >
                    {({ zoomIn, zoomOut, instance, resetTransform, ...rest }) => {
                      // if (refresh) {
                        
                      //   resetTransform();
                      //   console.log("refreshing transform")
                      //   setRefresh(false);
                      //   return;
                      // }
                      //console.log("render", initScale)

                      //(instance.transformState.scale <= initScale) || 
                      const curScale = parseFloat(instance.transformState.scale).toFixed(2);
                      const minScale = parseFloat(instance.setup.minScale).toFixed(2);
                      const isMinScale = (curScale <= minScale);
                      const isMaxScale = curScale >= 3;
                      //console.log("isMinScale", isMinScale, "isMaxScale", isMaxScale, instance.transformState.scale, initScale, instance.setup.minScale);
                      //console.log(instance.setup.minScale)
                      // let cnZoomIn = `bg-rba-gray p-[9px] cursor-pointer` 
                      // let cnZoomOut = cnZoomIn 
                      // if(zoomScales) {
                      //   cnZoomIn = `bg-rba-gray p-[9px] ${(isMaxScale) ? 'opacity-50' : 'cursor-pointer' }` 
                      //   cnZoomOut = `bg-rba-gray p-[9px] ${(isMinScale) ? 'opacity-50' : 'cursor-pointer' }`
                      // }
                      const cnZoomIn = `bg-black/50 ${(isMaxScale) ? 'opacity-50' : 'cursor-pointer' }` 
                      const cnZoomOut = `bg-black/50 ${(isMinScale) ? 'opacity-50' : 'cursor-pointer' }`

                      return <React.Fragment>
                      <div>
                        <TransformComponent wrapperStyle={wrapperStyle}>
                          <img src={src} className='h-full w-full object-contain ' id='image' alt={alt}  />
                        </TransformComponent> 
                        {!isSmall &&
                        <div className="absolute h-displayNoNavHt top-1/2 right-0" >
                          <div className="flex flex-col gap-y-2 mt-[-48px] ">
                          <button className={cnZoomIn+" w-[48px] h-[48px] "} onClick={() => zoomIn()} onMouseEnter={()=> setIsZoomInHover(true)} onMouseLeave={()=> setIsZoomInHover(false)}>
                            {!isZoomInHover ? <img src={zoomInIcon} alt="zoom in" width={48} height={48}/> : <img src={zoomInHoverIcon} alt="zoom in" width={48} height={48}/>}
                          </button>
                          <button className={cnZoomOut+" w-[48px] h-[48px] "} onClick={() => zoomOut()} onMouseEnter={()=> setIsZoomOutHover(true)} onMouseLeave={()=> setIsZoomOutHover(false)}>
                            {!isZoomOutHover ? <img src={zoomOutIcon} alt="zoom out" width={48} height={48}/> : <img src={zoomOutHoverIcon} alt="zoom out" width={48} height={48}/> }
                          </button>
                            {/* <img className={cnZoomIn} src={zoomInIcon} alt="" width={58} height={58} onClick={() => zoomIn()}/> */}
                            {/* <img className={cnZoomOut} src={zoomOutIcon} alt="" width={58} height={58} onClick={() => zoomOut()}/> */}
                          </div>
                        </div>
                        }
                        {/* <div className="absolute h-full top-1/2 right-0 w-[60px] cursor-pointer" >
                          <div className="flex flex-col gap-y-3 mt-[-36px]">
                            <img src={zoomInIcon} alt="" width={36} height={36} onClick={() => zoomIn()}/>
                            <img src={zoomOutIcon} alt="" width={36} height={36} onClick={() => zoomOut()}/>
                          </div>
                        </div> */}
                      </div>
                      </React.Fragment>
                      }}              
                </TransformWrapper>
                {/* }  */}
                
                {/* {!isSmall &&
                <div className="absolute h-displayNoNavHt top-1/2 right-0" >
                  <div className="flex flex-col gap-y-1 mt-[-42px] ">
                    <img className={cnZoomIn} src={zoomInIcon} alt="" width={42} height={42} onClick={() => zoomIn()}/>
                    <img className={cnZoomOut} src={zoomOutIcon} alt="" width={42} height={42} onClick={() => zoomOut()}/>
                  </div>
                </div>
                } */}
              </div>
            }
            
            <div ref={captionLayerRef} id="zoom-caption" className="absolute z-50 w-full bottom-0 py-5 bg-black/50" >
              {/* {getCaption()} */}
              {parse(caption)} 
              <span className=''>
              { (credit) ? " - " + parse(credit) : ""}
              </span>
              </div>
          </div>
          
        </div>

        }        
      </div>
    )
};

export {
  MediaItem
}


{/* <TransformWrapper
centerOnInit={true}
centerZoomedOut={true}
//options={transformOptions}
minScale={0.2}
initialScale={initScale}
// maxScale={4}
>
  {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
    // if (refresh) {
      
    //   resetTransform();
    //   console.log("refreshing transform")
    //   setRefresh(false);
    //   return;
    // }
    //console.log("render", initScale)

    //const isMinScale = instance.transformState.scale === initScale;
    //const isMaxScale = instance.transformState.scale === 4;

    <React.Fragment>
    <div><TransformComponent wrapperStyle={wrapperStyle}>
        <img src={src} className='h-full w-full object-contain ' id='image' alt=""  />
      </TransformComponent> 
      <div className="absolute h-full top-1/2 right-0 w-[60px] cursor-pointer" >
        <div className="flex flex-col gap-y-3 mt-[-36px]">
          <img src={zoomInIcon} alt="" width={36} height={36} onClick={() => zoomIn()}/>
          <img src={zoomOutIcon} alt="" width={36} height={36} onClick={() => zoomOut()}/>
        </div>
      </div>
      </div>
    </React.Fragment>
    )}              
</TransformWrapper> */}


// <div className="fixed z-10 w-full h-full flex flex-row flex-wrap items-end justify-end mt-4">
// <ButtonIcon text="hello" icon={zoomIcon} iconSize="30" />
// {/* onChange={event => handleChange(event, 'hello', 'world')} onClick={event => props.onClick(event, props.zoomsrc)}*/}
// </div>


// export const VideoItem = ({
//   onclose,
//   src,
//   caption,
//   credit,
//   subtitles
// }) => {

//   const [showCaption, setShowCaption] = useState(false);
//   const hasCaption = caption.length > 0 && credit.length > 0;
//   const config = !subtitles || subtitles.length < 2 ? {
//     file: { attributes: { controlsList: 'nodownload' } }
//   } : {
//     file: {
//       attributes: {
//         controlsList: 'nodownload',
//         crossOrigin: 'true'
//       },
//       tracks: [
//         {
//           kind: 'subtitles',
//           src: subtitles,
//           srcLang: 'en',
//           default: false,
//           label: 'Captions'
//         }
//       ]
//     }
//   }

//   console.log("media[curItem].filename", src)

//   return <>
//     <div className='flex h-full '>
//       <video autoPlay playsInline controls loop id='video' className='h-full w-full ' >
//         <source src={src} type='video/mp4'/>
//       </video>
//       {/* <div className="absolute right-0 top-2 w-[60px] cursor-pointer" onClick={onclose}>
//         <img src={closeIcon} alt="" width={32} height={32}/>
//       </div> */}

//       {/* <ReactPlayer
//         width='100%'
//         height='100%'
//         url={["./data/assets_5D/5D_background_security.mp4"]}
//         controls
//         playing
//         playsinline
//         loop
//         muted
//         config={config}
//       /> */}
//       {/* <div id='interface' className="relative h-full pointer-events-none  ">
//         <div className="h-full flex flex-wrap place-content-center p-2 ">
//           <div id='buttons' className='space-y-2 pointer-events-auto'> */}

//             {/* {
//               hasCaption && <div className='relative height-0'>
//                 <CircleButton
//                   className='bg-opacity-80'
//                   onClick={() => setShowCaption(!showCaption)}
//                 >
//                   <CaptionIcon width='50px' height='50px' fill="white" strokeWidth={0}/>
//                 </CircleButton>
//                 {
//                   showCaption && <div className='absolute right-0 top-0'>
//                     <CaptionBox
//                       caption={caption}
//                       credit={credit}
//                       toggleShowCaption={setShowCaption}
//                     />
//                   </div>
//                 }
//               </div>
//             } */}
//           {/* </div>
//         </div>
//       </div> */}

//     </div>
//   </>
// }

